<template>
      <v-dialog
          v-model="dialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
          style='z-index:20001;'
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" class="mybuttnr" small>mdi-cog
          </v-icon>
        </template>
        <v-card >
          <v-toolbar
              dark
              color="primary"
          >
            <v-btn
                icon
                dark
                @click="cancel()"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Settings</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                  dark
                  text
                  @click="save()"
              >
                Save
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container>
            <v-checkbox v-model="settings.tooltipsDisabled" label="Show Tooltips"></v-checkbox>
            <v-text-field v-model="settings.stravakeyId" label="Strava key id"></v-text-field>
            <v-text-field v-model="settings.stravakeyPolicy" label="Strava policy"></v-text-field>
            <v-text-field v-model="settings.stravakeySignature" label="Strava signature"></v-text-field>
            </v-container>
        </v-card>
      </v-dialog>
 </template>

<script>
import {AutoSettings} from "@/settings";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Settings",
  props: ['value'],
  data() {
    return {
      dialog: false,
      settings: new AutoSettings(),
    }
  },
  watch: {
    dialog : function (visible) {
      if (visible) {
        this.settings.copy(this.value);
      }
    }
  },
  methods: {
    save() {
      this.value.update(this.settings);
      this.dialog = false;
    },
    cancel() {
      this.dialog = false;
    }
  }

}
</script>

<style scoped>

</style>